import { ErrorMessage, useField } from 'formik';

import {
  DialogSub,
  DialogSubContent,
  DialogSubTrigger,
} from '@src/design-system/dialog';
import { CustomErrorMessage } from '@src/design-system/error-message';
import { Label } from '@src/design-system/label';
import { Checkbox } from '@src/design-system/checkbox';

import { TemplatesIcon } from '@shared/assets/icons/shared/templates-icon';

import { ChooseAppointmentTemplateSubModal } from '../../../sub-modals/choose-appointment-template-sub-modal';
import { CreateAppointmentTemplateSubModal } from '../../../sub-modals/create-appointment-template-sub-modal';
import { appointmentFormNames } from '@shared/forms/appointment';
import { HasPermission } from '@features/roles/guards/has-permission';
import { entities } from '@shared/constants/entities';
import { TiptapEditor } from '@src/shared/components/reusables/tiptap-editor';

export const AppointmentDetailsField = () => {
  const { description } = appointmentFormNames;
  const [fieldProps, , helpers] = useField(description);

  return (
    <div className='mb-6'>
      <Label htmlFor='details'>Appointment Details</Label>
      <div className='border focus-within:border-active-border overflow-hidden focus-within:ring-[3px] transition-all focus-within:ring-ring/10 bg-primary-30 border-pale-border rounded-lg has-data-error:border-destructive has-data-error:ring-[3px] has-data-error:ring-destructive/15 has-data-error:focus-within:border-destructive has-data-error:focus-within:ring-destructive/15'>
        <TiptapEditor
          value={fieldProps.value}
          onChange={helpers.setValue}
          contentClassName='border-0'
        />

        <DialogSub>
          <div className='p-3 flex justify-between pt-0 bottom-0'>
            <HasPermission
              entity={entities.meetingTemplate}
              action='view'
            >
              <DialogSubTrigger
                value='chooseTemplate'
                className='w-fit'
              >
                <button
                  type='button'
                  className='text-sm p-2 bg-primary-100 rounded-lg flex items-center gap-2 hover:bg-primary-200 transition-colors cursor-pointer text-primary-900'
                >
                  <TemplatesIcon />
                  Templates
                </button>
              </DialogSubTrigger>

              <DialogSubContent
                vertical='top'
                value='chooseTemplate'
              >
                <ChooseAppointmentTemplateSubModal />
              </DialogSubContent>
            </HasPermission>

            <HasPermission
              entity={entities.meetingTemplate}
              action='add'
            >
              <DialogSubTrigger
                value='createTemplate'
                className='w-fit text-primary-900 flex items-center gap-2'
              >
                <Checkbox id='saveTemplate' />
                <Label
                  htmlFor='saveTemplate'
                  className='mb-0 font-normal'
                >
                  Save as template
                </Label>
              </DialogSubTrigger>

              <CreateAppointmentTemplateSubModal />
            </HasPermission>
          </div>
        </DialogSub>
      </div>

      <ErrorMessage
        name={description}
        component={CustomErrorMessage}
      />
    </div>
  );
};
